import { render, staticRenderFns } from "./portraitSalesman.vue?vue&type=template&id=2b18860c&scoped=true"
import script from "./portraitSalesman.vue?vue&type=script&lang=js"
export * from "./portraitSalesman.vue?vue&type=script&lang=js"
import style0 from "./portraitSalesman.vue?vue&type=style&index=0&id=2b18860c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18860c",
  null
  
)

export default component.exports